/**
 * Route for `invoice-attachment-bank-details-compliance-docs`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InvoiceAttachmentBankDetailsComplianceDocsPage } from "../features/invoice-attachment-bank-details-compliance-docs/InvoiceAttachmentBankDetailsComplianceDocsPage";

export const invoiceAttachmentBankDetailsComplianceDocsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/invoice-attachment-bank-details-compliance-docs",
	component: InvoiceAttachmentBankDetailsComplianceDocsPage,
});

export default invoiceAttachmentBankDetailsComplianceDocsRoute;
